// extracted by mini-css-extract-plugin
module.exports = {"main":"Slider_main__2q_sx","label":"Slider_label__65Znf","container":"Slider_container__2Pa3J","slider":"Slider_slider__3iECS","rangeValue":"Slider_rangeValue__37aw5"};